<template>
  <el-form ref="clothAssessmentForm"
           label-width="110px"
           inline
           label-position="right"
           size="mini"
           :model="clothAssessment"
           style="display: flex;flex-wrap: wrap;justify-content: flex-start;">
    <el-form-item v-for="(clothAssessmentItem,key) in sortedConfig"
                  :key="key"
                  :label="clothAssessmentItem.title"
                  :prop="key"
                  :required="!!clothAssessmentItem.required"
                  :class="{'alert':worningKeys[key]}">

      <template v-if="readonly||readonly===''">
        <el-select v-if="clothAssessmentItem.type==='select'"
                   :value="clothAssessment[key]">
          <el-option v-for="option in clothAssessmentItem.options"
                     :key="option"
                     :value="option"></el-option>
        </el-select>
        <el-select v-else-if="clothAssessmentItem.type==='input-select'"
                   :value="clothAssessment[key]">
          <el-option v-for="option in clothAssessmentItem.options"
                     :key="option"
                     :value="option"></el-option>
        </el-select>
        <el-input v-else-if="clothAssessmentItem.type==='input'"
                  style="width: 173px;"
                  :value="clothAssessmentItem[key]"
                  placeholder="请输入内容"
                  readonly></el-input>
        <span v-else
              class="el-alert--error"
              style="width: 173px;">错误的布面信息配置.在{{[key]}}项中,类型{{[clothAssessmentItem.type]}}不存在</span>
      </template>
      <template v-else>
        <el-select v-if="clothAssessmentItem.type==='select'"
                   v-model="clothAssessment[key]">
          <el-option v-for="option in clothAssessmentItem.options"
                     :key="option"
                     :value="option"></el-option>
        </el-select>
        <el-autocomplete v-else-if="clothAssessmentItem.type==='input-select'"
                         style="width: 173px;"
                         v-model="clothAssessment[key]"
                         :fetch-suggestions="function(qryStr,cb){cb(clothAssessmentItem.options.filter(option=>option.indexOf(qryStr)!==-1).map(item=>({value:item})))}"
                         placeholder="请输入内容"></el-autocomplete>
        <el-input v-else-if="clothAssessmentItem.type==='input'"
                  style="width: 173px;"
                  v-model="clothAssessmentItem[key]"
                  placeholder="请输入内容"
                  readonly></el-input>
        <span v-else
              class="el-alert--error"
              style="width: 173px;">错误的布面信息配置.在{{[key]}}项中,类型{{[clothAssessmentItem.type]}}不存在</span>
      </template>

    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    value: {
      default: () => ({}),
    },
    config: {
      default: () => ({}),
    },
    worningKeys: {
      default: () => ({}),
    },
    readonly: {
      default: false,
    },
  },
  data() {
    return {
      clothAssessment: this.value,
    }
  },
  computed: {
    validate() {
      return this.$refs.clothAssessmentForm.validate
    },
    sortedConfig() {
      const config = this.config
      const result = {}
      Object.keys(config)
        .sort((a, b) => (config[a].order < config[b].order ? 1 : -1))
        .forEach(key => {
          result[key] = config[key]
        })
      return result
    },
  },
  watch: {
    value(val) {
      this.clothAssessment = val
    },
    clothAssessment(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style lang="scss">
.alert {
  .el-input__inner {
    border-color: #f56c6c !important;
  }
}
</style>
